// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { IndexedDB } from './IndexedDB';
export var UserIndexedDBStore;
(function (UserIndexedDBStore) {
    UserIndexedDBStore["WD_SETTINGS"] = "WDSettings";
    UserIndexedDBStore["WM_SETTINGS"] = "WMSettings";
    UserIndexedDBStore["WL_SHEETS"] = "WLSheets";
    UserIndexedDBStore["EVENT_LOG"] = "EventLog";
})(UserIndexedDBStore || (UserIndexedDBStore = {}));
export var UserIndexedDBKey;
(function (UserIndexedDBKey) {
    UserIndexedDBKey["USER_ID"] = "userId";
    UserIndexedDBKey["EVENT_ID"] = "eventId";
    UserIndexedDBKey["TIMESTAMP"] = "timestamp";
})(UserIndexedDBKey || (UserIndexedDBKey = {}));
const config = {
    dbName: 'UserDB',
    version: 1, // In the future need increase version for migration on a new scheme.
    stores: [
        {
            storeName: UserIndexedDBStore.WD_SETTINGS,
            keyPath: UserIndexedDBKey.USER_ID,
            autoIncrement: false
        },
        {
            storeName: UserIndexedDBStore.WM_SETTINGS,
            keyPath: UserIndexedDBKey.USER_ID,
            autoIncrement: false
        },
        {
            storeName: UserIndexedDBStore.WL_SHEETS,
            keyPath: UserIndexedDBKey.USER_ID,
            autoIncrement: false
        },
        {
            storeName: UserIndexedDBStore.EVENT_LOG,
            keyPath: UserIndexedDBKey.EVENT_ID,
            autoIncrement: true,
            indexes: [
                { name: UserIndexedDBKey.USER_ID, keyPath: UserIndexedDBKey.USER_ID, options: { unique: false } },
                { name: UserIndexedDBKey.TIMESTAMP, keyPath: UserIndexedDBKey.TIMESTAMP, options: { unique: false } }
            ]
        }
    ]
};
export const UserIndexedDB = new IndexedDB(config);
